import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Target, Eye, Award, Users, Clock, Shield, Headphones } from 'lucide-react';

export default function About() {
  return (
    <div>
      <section className="py-16 md:py-20" data-testid="about-hero-section">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <Badge variant="secondary" className="mb-4">Nosotros</Badge>
            <h1 className="text-4xl sm:text-5xl font-display font-semibold tracking-tight mb-6">Sobre Kind Technologies</h1>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed" data-testid="about-main-description">
              Kind Technologies es el distribuidor mayorista de AudioCodes en México y un socio especializado en soluciones de comunicaciones empresariales y de operadores. Ayudamos a nuestros clientes a diseñar, implementar y soportar plataformas de voz, Microsoft Teams, SBCs, Gateways, Contact Center y Comunicaciones Unificadas con el respaldo de expertos certificados, soporte 24x7 e inventario local.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 bg-secondary/30" data-testid="about-history-section">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <h2 className="text-xl md:text-2xl font-display font-semibold">Nuestra Historia</h2>
              <div className="space-y-4 text-sm text-muted-foreground leading-relaxed" data-testid="about-history-text">
                <p>Con más de 12 años de experiencia en el mercado mexicano, Kind Technologies se ha consolidado como un referente en soluciones AudioCodes para operadores, integradores y empresas.</p>
                <p>Hemos participado en proyectos de misión crítica para telecomunicaciones, colaboración empresarial, Microsoft Teams y centros de contacto, proporcionando tecnología, servicios profesionales y soporte especializado.</p>
                <p>Nuestro enfoque combina conocimiento técnico, atención local y acompañamiento durante todo el ciclo de vida del proyecto, desde el diseño y la implementación hasta la operación y soporte continuo.</p>
              </div>
            </div>
            <div className="space-y-6">
              <h2 className="text-xl md:text-2xl font-display font-semibold">Lo que nos define</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { icon: Target, label: 'Especialización', desc: 'Distribuidor mayorista AudioCodes para México' },
                  { icon: Award, label: 'Experiencia', desc: 'Más de una década implementando proyectos de comunicaciones críticas' },
                  { icon: Headphones, label: 'Soporte Local', desc: 'Ingenieros certificados, inventario local y soporte 24x7' },
                  { icon: Shield, label: 'Confianza', desc: 'Respaldando operadores, integradores y empresas líderes' },
                ].map(v => (
                  <Card key={v.label} data-testid={`about-define-${v.label.toLowerCase().replace(/\s+/g, '-')}`}>
                    <CardContent className="p-4 space-y-2">
                      <v.icon className="h-5 w-5 text-muted-foreground" />
                      <p className="font-display font-semibold text-sm">{v.label}</p>
                      <p className="text-xs text-muted-foreground">{v.desc}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-testid="about-stats-section">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl md:text-2xl font-display font-semibold mb-8">Cifras Clave</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { num: '12+', label: 'Años impulsando telecomunicaciones', icon: Clock },
              { num: '13M+', label: 'Llamadas procesadas diariamente en proyectos soportados', icon: Users },
              { num: '24x7', label: 'Soporte técnico especializado', icon: Eye },
              { num: '100%', label: 'Enfoque en soluciones AudioCodes', icon: Shield },
            ].map(s => (
              <Card key={s.label} data-testid={`about-stat-${s.num}`}>
                <CardContent className="p-6 text-center space-y-2">
                  <p className="text-2xl md:text-3xl font-display font-semibold tabular-nums">{s.num}</p>
                  <p className="text-xs text-muted-foreground">{s.label}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
